import * as React from "react";
import Box from "../box";
import type { ContainerProps } from "./container.types";

function Container(props: ContainerProps) {
  return (
    <Box
      width="$full"
      marginX="auto"
      paddingX="$8"
      maxWidth={props.maxWidth}
      attributes={props.attributes}
    >
      {props.children}
    </Box>
  );
}

Container.defaultProps = { maxWidth: "prose" };

export default Container;
